// Shared JSON helpers for the model parsers. Dart's `as int?` / `as num?`
// casts tolerate Postgres returning numbers as either ints or doubles and
// JSON nulls; these helpers reproduce that leniency in one place so each
// `fromJson` reads as cleanly as the Dart factory it ports.

export type Json = Record<string, unknown>;

export function asString(v: unknown): string | undefined {
  return typeof v === 'string' ? v : undefined;
}

export function asNum(v: unknown): number | undefined {
  return typeof v === 'number' ? v : undefined;
}

export function asInt(v: unknown): number | undefined {
  return typeof v === 'number' ? Math.trunc(v) : undefined;
}

export function asBool(v: unknown): boolean | undefined {
  return typeof v === 'boolean' ? v : undefined;
}

/** Parses an ISO timestamp string into a Date, or undefined when null. */
export function asDate(v: unknown): Date | undefined {
  return typeof v === 'string' ? new Date(v) : undefined;
}

/** Coerces a Postgres text[] / jsonb array into a string[] of non-empty entries. */
export function asStringList(v: unknown): string[] {
  if (!Array.isArray(v)) return [];
  return v.filter((e): e is string => typeof e === 'string');
}
